import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setAuthToken, getToken } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = getToken();
    if (!t) { setLoading(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data))
      .catch(() => setAuthToken(null))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setAuthToken(r.data.token);
    sessionStorage.setItem("qedara_post_login_pending", "1");
    setUser(r.data.user);
    return r.data.user;
  };

  const register = async (name, email, password) => {
    const r = await api.post("/auth/register", { name, email, password });
    setAuthToken(r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  // Request a password-reset email. Always resolves (server never leaks existence).
  const forgot = async (email) => {
    await api.post("/auth/forgot", { email });
  };

  // Complete a reset with a token from the email link; logs the user in.
  const reset = async (token, password) => {
    const r = await api.post("/auth/reset", { token, password });
    setAuthToken(r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  // Accept a workspace invite: create account (name + password) and log in.
  const acceptInvite = async (token, name, password) => {
    const r = await api.post("/auth/accept-invite", { token, name, password });
    setAuthToken(r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    setAuthToken(null);
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, forgot, reset, acceptInvite, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
